/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Toggle_MenuInputs */

const en_common_toggle_menu = /** @type {(inputs: Common_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle menu`)
};

const es_common_toggle_menu = /** @type {(inputs: Common_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar menu`)
};

/**
* | output |
* | --- |
* | "Toggle menu" |
*
* @param {Common_Toggle_MenuInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_toggle_menu = /** @type {((inputs?: Common_Toggle_MenuInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Toggle_MenuInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_toggle_menu(inputs)
	return es_common_toggle_menu(inputs)
});